module.exports = __webpack_public_path__ + "img/8.f31ee1e7.jpg";